import type { JSX } from 'react';
import { useForm } from 'react-hook-form';
import type { Segment } from '@echo-work-platform/shared-types';
import { CrudTable, type Column } from '@/components/shared/crud-table';

const columns: Column<Segment>[] = [
  { key: 'name', label: 'Név' },
  { key: 'description', label: 'Leírás' },
  {
    key: 'isDefault',
    label: 'Default?',
    render: (s) =>
      s.isDefault ? (
        <span className="rounded bg-accent-50 px-2 py-0.5 text-xs text-accent-700">DEFAULT</span>
      ) : (
        ''
      ),
  },
];

function SegmentForm({
  initial,
  onSubmit,
  onCancel,
}: {
  initial: Partial<Segment> | null;
  onSubmit: (v: Partial<Segment>) => void;
  onCancel: () => void;
}): JSX.Element {
  const { register, handleSubmit } = useForm<Partial<Segment>>({
    defaultValues: {
      name: initial?.name ?? '',
      description: initial?.description ?? '',
      isDefault: initial?.isDefault ?? false,
    },
  });
  return (
    <form className="space-y-4" onSubmit={(e) => void handleSubmit((v) => onSubmit(v))(e)}>
      <div>
        <label className="label">Név</label>
        <input className="input" {...register('name', { required: true })} />
      </div>
      <div>
        <label className="label">Leírás</label>
        <textarea className="input" {...register('description')} />
      </div>
      <div className="flex items-center gap-2">
        <input type="checkbox" {...register('isDefault')} id="isDefault" />
        <label htmlFor="isDefault" className="text-sm">
          Default szegmens (minden authentikált user tagja lesz)
        </label>
      </div>
      <div className="flex justify-end gap-2">
        <button type="button" className="btn-secondary" onClick={onCancel}>
          Mégse
        </button>
        <button type="submit" className="btn-action">
          Mentés
        </button>
      </div>
    </form>
  );
}

export function Segments(): JSX.Element {
  return (
    <CrudTable<Segment>
      title="Segments"
      endpoint="/api/admin/segments"
      columns={columns}
      itemTitle={(s) => s.name}
      renderForm={(i, s, c) => <SegmentForm initial={i} onSubmit={s} onCancel={c} />}
    />
  );
}
